import isPdf from './isPdf';
import { isFeatureEnabled } from 'owa-feature-flags';
import AttachmentType from 'owa-service/lib/contract/AttachmentType';

export default function shouldPreviewPdfJs(attachment: AttachmentType): boolean {
    return isFeatureEnabled('doc-SxS-pdfJsPreview') && isPdf(attachment);
}
